<template>
  <div class="ms-form">
    <q-form @submit="onSubmit">
      <div class="ms-form-grid">
        <CustomSelect
          class="ms-form-wide"
          label="Материал"
          :required="true"
          :options="materials"
          option-value-key="material_id"
          option-label-key="name"
          :loading="materialsLoading"
          :disabled="isEdit"
          :value="form.material_id"
          @change="(v) => (form.material_id = v || null)"
        />
        <CustomInput
          label="Скидка, % (от 0 до 20)"
          type="number"
          :required="true"
          :value="form.discount_percent"
          @change_input="(v) => (form.discount_percent = v)"
        />
        <div class="promo-flags">
          <CustomCheckbox label="Суммирование" :value="form.is_sum" @change="(v) => (form.is_sum = !!v)" />
          <CustomCheckbox label="Активность" :value="form.is_active" @change="(v) => (form.is_active = !!v)" />
        </div>
        <p v-if="isEdit" class="ms-section__hint ms-form-wide">
          Материал в созданной скидке не меняется — для другого материала создайте новую скидку.
        </p>
      </div>
      <CustomModalFooter :btn-loading="loading" />
    </q-form>
  </div>
</template>

<script>
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomInput from "@/components/form/CustomInput";
import CustomSelect from "@/components/form/CustomSelect";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import { promoMaterialsAPI } from "@/views/PromoMaterials/api";

export default {
  name: "AddPromoMaterial",
  components: { CustomModalFooter, CustomInput, CustomSelect, CustomCheckbox },
  props: ["data"],
  data() {
    const body = this.data?.body;
    return {
      loading: false,
      materials: [],
      materialsLoading: false,
      form: {
        promo_material_id: body?.promo_material_id || 0,
        material_id: body?.material_id || null,
        discount_percent: body?.discount_percent ?? "",
        is_sum: !!body?.is_sum,
        is_active: body ? !!body.is_active : true,
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.form.promo_material_id;
    },
  },
  mounted() {
    this.loadMaterials();
  },
  methods: {
    async loadMaterials() {
      this.materialsLoading = true;
      try {
        const res = await promoMaterialsAPI.getMaterials();
        this.materials = res?.data || [];
      } finally {
        this.materialsLoading = false;
      }
    },
    async onSubmit() {
      this.loading = true;
      try {
        await this.data?.onSubmit(this.form);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.promo-flags {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 20px;
  min-height: var(--ms-control-h);
  align-self: end;
}
</style>
